







import Vue from 'vue'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import ApartmentUnit from '@/components/valuation/unit/ApartmentUnit.vue'
import HouseUnit from '@/components/valuation/unit/HouseUnit.vue'

export default Vue.extend({
  components: {
    ApartmentUnit,
    HouseUnit,
  },
  data() {
    return {
      PropertyType,
    }
  },
  computed: {
    propertyType(): PropertyType {
      return this.$store.getters['valuationProcess/propertyType']
    },
  },
})
